import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Header } from './header';
import { Footer } from './footer';
import { SearchOverlay } from './search-overlay';
import { WhatsappFloat } from './whatsapp-float';
import { Analytics } from './analytics';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-root',
  imports: [RouterOutlet, Header, Footer, SearchOverlay, WhatsappFloat],
  template: `
    <app-header></app-header>
    <main>
      <router-outlet></router-outlet>
    </main>
    <app-footer></app-footer>
    <app-search-overlay></app-search-overlay>
    <app-whatsapp-float></app-whatsapp-float>
  `,
  styles: [`
    :host { display: block; }
  `],
})
export class App {
  // Injecting instantiates the singleton, which kicks off (browser-only,
  // lazy-loaded) GA4 initialization and SPA page_view tracking.
  private analytics = inject(Analytics);
}
